import React from "react";

import "./style.css";
import { Input, FormGroup } from "reactstrap";

export default function TextInputOutline({
  type = "text",
  containerClasses = "",
  name,
  containerStyles = {},
  inputStyles = {},
  label = "Login",
  errorMessage = "",
  value = "",
  onChange = function() {}
}) {
  return (
    <div className="text-input-outline-main-container">
      <div
        className={`text-input-outline-container ${containerClasses} text-input-outline-container-error`}
        style={containerStyles}
      >
        <FormGroup>
          {/* <label
            className={`${errorMessage && "text-input-outline-label-error"}`}
          >
            {label}
          </label> */}
          <Input
            value={value}
            onChange={onChange}
            name={name}
            placeholder={label}
            type={type}
            className="text-input-outline"
            style={inputStyles}
          />
        </FormGroup>
      </div>
      {errorMessage && <label>{errorMessage}</label>}
    </div>
  );
}
